import { useState, useCallback } from "react";

const forceValidTotalSteps = (steps) => Math.max(0, steps);

export const useStepper = (totalSteps = 0) => {
  const [steps, setSteps] = useState(forceValidTotalSteps(totalSteps));
  const [activeStep, setActiveStep] = useState(steps === 0 ? -1 : 0);

  const updateTotalSteps = useCallback(
    (newSteps) => {
      const validNewSteps = forceValidTotalSteps(newSteps);
      if (validNewSteps === steps) return;

      setSteps(validNewSteps);
      setActiveStep(validNewSteps === 0 ? -1 : 0);
    },
    [steps]
  );

  const handleNext = useCallback(() => {
    setActiveStep((prevActiveStep) => Math.min(steps, prevActiveStep + 1));
  }, [steps]);

  const handleBack = useCallback(() => {
    setActiveStep((prevActiveStep) => Math.max(0, prevActiveStep - 1));
  }, []);

  return {
    steps,
    handleNext,
    handleBack,
    activeStep,
    setActiveStep,
    updateTotalSteps,
  };
};
